/* eslint-disable import/prefer-default-export */
import { UsageInfo } from '@src/endpoints/services/commonHdr.service'
import { sortedByTimestamp } from '@src/modules/user.activity/configurations/sorting.configurations'
import { defaultPageSize } from '@src/constants/grid'

export interface UsageItem extends UsageInfo {
  identity_account?: string
  resource_account?: string
}

export interface TableOptions {
  pageNumber?: number
  pageSize?: number
  sortField?: string
  asc?: boolean
  searchValue?: string
  searchFields?: string[]
}

// Reducer
export const defaultState = {
  query: null as string,
  pagesCount: 0,
  logDetails: null as string,
  isPending: false,
  usageInfoList: [] as UsageItem[],
  tableOptions: {
    pageNumber: 0,
    pageSize: defaultPageSize,
    sortField: sortedByTimestamp[0].id,
    asc: !sortedByTimestamp[0].desc,
    searchValue: '',
    searchFields: [] as string[]
  } as TableOptions,
  startTime: null as Date,
  endTime: null as Date
}

export type UsageState = typeof defaultState
